import { securedOpenbetHttpClient } from "@/api/openbet-http-client";
import { EventAccessStream } from "@/api/interfaces/event-access-stream";
import { CashoutSubscription } from "@/api/interfaces/cashout-subscription";
import { appendEnvSuffix } from "@/api/http-client-helpers";

const path = appendEnvSuffix("/sports-service");

export async function getEventAccessStream(params: { eventId: string | number }): Promise<EventAccessStream> {
    const response = await securedOpenbetHttpClient.post(`${path}/streams/access/event/${params.eventId}`, {});

    return response?.data;
}

export async function getCashoutSubscription(): Promise<CashoutSubscription> {
    const response = await securedOpenbetHttpClient.post(`${path}/data-streams/subscription/CASHOUT`, {});

    return response?.data;
}
